"use client";
import React from "react";

export default function WithSidebarRight({ children, ...props }) {
  const [children1, children2] = React.Children.toArray(children); // Split the children

  // sidebar droite masquée sur mobile
  return (
    <div className="grid grid-cols-12">
      <div className="col-span-12 sm:col-span-8 sm:pr-2 min-h-screen">
        {children1}
      </div>
      {children2 ? (
        <div className="sm:col-span-4 hidden sm:block sm:border-l border-base-content/10 sm:pl-2">
          {children2}
        </div>
      ) : null}
    </div>
  );

  // sidebar droite visible sur mobile
  // return (
  //   <div className="grid grid-cols-12 gap-4">
  //     <div className="col-span-12 sm:col-span-8 sm:pr-2">{children1}</div>
  //     {children2 ? (
  //       <div className="col-span-12 sm:col-span-4 sm:border-l border-base-content/10 sm:pl-2 flex sm:block">
  //         {children2}
  //       </div>
  //     ) : null}
  //   </div>
  // );
}
